import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useSupabaseClient } from "@supabase/auth-helpers-react";
import { toast } from "sonner";
import { DashboardSidebar } from "./dashboard/DashboardSidebar";

interface MenuItem {
  id: string;
  title: string;
  icon: string;
}

interface DashboardLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
  menuItems: MenuItem[];
}

export const DashboardLayout = ({ children, activeTab, onTabChange, menuItems }: DashboardLayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const supabase = useSupabaseClient();

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate("/auth");
    } catch (error) {
      console.error("Error logging out:", error);
      toast.error("حدث خطأ أثناء تسجيل الخروج");
    }
  };

  const handleHomeClick = () => {
    // Set the flag to indicate user explicitly wants to go to home
    sessionStorage.setItem('userRequestedHome', 'true');
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-background flex">
      <DashboardSidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        activeTab={activeTab}
        onTabChange={onTabChange}
        menuItems={menuItems}
        onLogout={handleLogout}
        onHomeClick={handleHomeClick}
      />

      <div className="flex-1 overflow-auto">
        <div className="container py-6">
          {children}
        </div>
      </div>
    </div>
  );
};